import { createContext } from 'react';

import type {
  DataFilePreview,
  DataFilePreviewV1,
  DataFilePreviewV2,
} from '../../api/types.js';

export type DataFileContextValue<
  T extends DataFilePreviewV1 | DataFilePreviewV2 = DataFilePreview,
> = {
  dataFileId: string;
  dataFilePreview: T;
  actionsContainerElement: HTMLDivElement | null;
  setActionsContainerElement: React.RefCallback<HTMLDivElement>;
  goToNextStep: () => Promise<void>;
  goToPrevStep: () => Promise<void>;
  isSubmitting: boolean;
  showUploadFileDialog: () => void;
  hideUploadFileDialog: () => void;
};

export const DataFileContext: React.Context<DataFileContextValue> =
  createContext<DataFileContextValue>({} as DataFileContextValue);
